import { BoxTitles } from "@boxes/BoxTitles";
import { FlowBox } from "@boxes/FlowBox";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import classnames from "classnames/bind";
import { memo } from "react";
import { Handle } from "reactflow";

export default memo(({ id, data, selected, isConnectable }) => {
  const cx = classnames.bind(style);
  const getSubline = () => {
    let str = "total";

    if (data.min !== undefined) {
      const minSign = data.inclusive ? "≤" : "<";
      str = `${data.min} ${minSign} ${str}`;
    }

    if (data.max !== undefined) {
      const maxSign = data.inclusive ? "≤" : "<";
      str = `${str} ${maxSign} ${data.max}`;
    }

    return str != "idade" ? str : "";
  };

  return (
    <div className={cx({ selected: selected })}>
      <Handle
        type="target"
        position="left"
        className={style.handleTarget}
        isConnectable={isConnectable}
      />
      <div className={style.inner}>
        <div className={style.body}>
          <div className="d-flex justify-between align-center">
            <div className={`${style.title} flex`}>
              {BoxTitles.ConsumedProductsConditional}
            </div>
            <div
              className={`${style.icon} pointer`}
              onClick={(e) =>
                FlowBox.interceptClickAndModifyEvent(e, {
                  audience: true,
                  boxId: id,
                })
              }
            >
              <i className="fal fa-users" />
            </div>
          </div>
          {(data.min || data.max) && (
            <div className={style.subline}>{getSubline()}</div>
          )}
        </div>
      </div>
      <Handle
        type="source"
        id="has"
        position="right"
        className={style.handleYes}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        id="hasNot"
        position="right"
        className={style.handleNo}
        isConnectable={isConnectable}
      />
    </div>
  );
});
